import React from "react";
import { colors } from "../../styles/variables";
import { HexColor } from "../../types";

export const SearchIconSvg = ({
  color = colors.gray500,
  width = "24",
  height = "24",
}: {
  color?: HexColor;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11" cy="11" r="6.2" stroke={color} strokeWidth="1.6" />
    <path
      d="M16 16L20 20"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);
